<template>
  <div class="small mb-2">
    <!-- #1759: what an absence does to the worker's orders (BWorkers.SetAbsentAsync) -->
    <div v-if="canEdit" class="alert alert-warning py-1 px-2 mb-2">
      <strong>Previdno pri vpisu odsotnosti:</strong> ko je delavec odsoten (takoj za današnji dan, sicer zjutraj
      tistega dne), se njegovi sprejeti nalogi vrnejo v Active in odvzamejo delavcu, odprte medskladiščnice zanje pa se
      prekličejo. Izjema so nalogi, za katere je material že v vozilu. Izbris odsotnosti tega
      <strong>ne</strong> razveljavi.
    </div>
    <div class="d-flex flex-wrap align-items-center column-gap-3 row-gap-1">
      <span class="fw-semibold">{{ details ? "Klik:" : "Klik nastavi dan kot:" }}</span>
      <div v-for="m in modes" :key="m.value" class="form-check form-check-inline m-0">
        <input
          class="form-check-input"
          type="radio"
          :name="name"
          :id="`${name}-${m.value}`"
          :value="m.value"
          v-model="mode"
        />
        <label class="form-check-label" :for="`${name}-${m.value}`">
          <!-- the picker doubles as a legend -->
          <span class="swatch border" :class="swatchClass[m.value]">{{ m.short || " " }}</span
          >{{ m.text }}
        </label>
      </div>
    </div>
    <div v-if="canEdit" class="text-muted">Shift + klik nastavi vse dneve od zadnjega klika.</div>
  </div>
</template>

<script setup>
import { computed, useId } from "vue"
import { ABSENCE_MODES } from "../composition-api/useAbsences"

defineOptions({ name: "AbsenceModePicker" })

const mode = defineModel({ type: String, required: true })
const props = defineProps({
  canEdit: { type: Boolean, default: true },
  details: { type: Boolean, default: false }, // extra "Details" mode: click opens the day instead of setting it
})

const DETAILS_MODE = { value: "Details", text: "Podrobnosti", short: "i" }
const modes = computed(() => [...(props.canEdit ? ABSENCE_MODES : []), ...(props.details ? [DETAILS_MODE] : [])])

const name = `absence-mode-${useId()}`
const swatchClass = {
  Vacation: "bg-primary-subtle",
  SickLeave: "bg-warning-subtle",
  Present: "bg-body",
  Details: "bg-body text-primary",
}
</script>

<style scoped>
.swatch {
  display: inline-block;
  width: 1.4em;
  line-height: 1.3em;
  margin-right: 0.3em;
  text-align: center;
  font-weight: bold;
  font-size: 0.85em;
  border-radius: 0.15em;
}
</style>
